import { render, staticRenderFns } from "./ForumWidget.vue?vue&type=template&id=82350150&scoped=true&"
import script from "./ForumWidget.vue?vue&type=script&lang=js&"
export * from "./ForumWidget.vue?vue&type=script&lang=js&"
import style0 from "./ForumWidget.vue?vue&type=style&index=0&id=82350150&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82350150",
  null
  
)

component.options.__file = "ForumWidget.vue"
export default component.exports